/**
 * Stream component - uses infinite scroller, loading spinner, and post components.
 */

import * as React from 'react';

import './Stream.css';

const Infinite = require('react-infinite-scroller');

import { observer, inject } from 'mobx-react';
import { StreamPost } from './StreamPost/StreamPost';
import { PostStore } from '../../stores/PostStore';

interface StreamProps {
    active: number;
    setActive: (i: number) => void;
}

/**
 * Creates a infinite loading stream of posts from the current postset in the PostStore.
 *
 * @class Stream
 * @extends {(React.Component<StreamProps & { postStore?: PostStore }>)}
 */
@inject(allStores => ({
    postStore: allStores.postStore as PostStore,
}))
@observer
class Stream extends React.Component<StreamProps & { postStore?: PostStore }> {
    render() {
        return (
            <Infinite
                pageStart={1}
                loadMore={this.props.postStore!.initiateSearch}
                threshold={1500}
                hasMore={this.props.postStore!.hasMore}
                useWindow={false}
                initialLoad={false}
            >
                {this.props
                    .postStore!.posts.filter(p => p.file_ext !== 'swf')
                    .map((post, index) => (
                        <StreamPost
                            onEnter={this.props.setActive}
                            id={index}
                            active={this.props.active === index}
                            key={post.id}
                            post={post}
                            position={index}
                        />
                    ))}

                {this.props.postStore!.lastSearchEmpty && (
                    <div style={{ textAlign: 'center', height: '75px' }}> no search results found :( </div>
                )}
            </Infinite>
        );
    }
}

export { Stream };



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Stream/Stream.tsx